import type { ListPageConfig } from '@/lib/filters/types'

/**
 * The vendor directory filters CLIENT-SIDE over the loaded rows — `useManagedVendors()` takes no
 * arguments — so neither field is `serverSide`. The config still earns its place: it gives the
 * route a search schema, gives the page a `FilterBar` instead of a raw `<Input>` beside a loose
 * `FilterSelect`, and puts the term in the URL so a filtered view can be shared.
 *
 * `service` options are empty here and filled at runtime from the loaded vendors, the same split
 * `EntitiesPage` uses for its client list: the base config is what the route validates against,
 * the enriched one is what `FilterBar` renders. A select with no options is left out of
 * `validateSearch`'s allow-list check, so the route accepts any string for it — which is correct,
 * because the valid set is data, not a constant.
 */
export const VENDORS_ROUTE_CONFIG: ListPageConfig = {
  routeId: '/providers/',
  pageId: 'vendors',
  fields: [
    {
      id: 'q',
      label: 'Search',
      type: 'search',
      placeholder: 'Search vendors…',
    },
    {
      id: 'service',
      label: 'Service',
      type: 'select',
      allLabel: 'All services',
      options: [],
    },
  ],
}
